import React from 'react';

const DropdownHeader = ({ children }) => (
  <div className="dropdown-header">{children}</div>
);

export default DropdownHeader;
